import * as React from "react";
import { connect } from "react-redux";
import * as Redux from "redux";

import { TrackAnalyticsEvent } from '../actions/analytics';
import { Events } from '../modules/analytics';
import '../styles/headerStyling.scss';
import { Tooltip, getParameterByName, whiteCheckGreenBackgroundIcon, TeacherPreviewMenuButton, hasTeacherPreview } from '../../Shared/index';
import { HIGH_SCHOOL_BECAUSE_BUT_SO, MIDDLE_SCHOOL_BECAUSE_BUT, MIDDLE_SCHOOL_BECAUSE_SO } from '../../../constants/evidence';
import { getActivitySteps } from '../helpers/containerActionHelpers';

const ACTIVITY_TYPE_TAG_LABEL: { [key: string]: string } = {
  [HIGH_SCHOOL_BECAUSE_BUT_SO]: 'Cause • Contrast • Consequence',
  [MIDDLE_SCHOOL_BECAUSE_BUT]: 'Cause • Contrast',
  [MIDDLE_SCHOOL_BECAUSE_SO]: 'Cause • Consequence',
}

const logoSrc = `${window.postbuildEnv.CDN_URL}/images/logos/quill-logo-white-2022.svg`
const mobileLogoSrc = `${window.postbuildEnv.CDN_URL}/images/logos/quill-logo-white-mobile.svg`
const helpIcon = `${window.postbuildEnv.CDN_URL}/images/icons/icons-help-white.svg`
const checkIcon = <img alt={whiteCheckGreenBackgroundIcon.alt} src={whiteCheckGreenBackgroundIcon.src} />;

export class Header extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      sessionID: getParameterByName('student', window.location.href)
    }
  }

  goToLMS = () => {
    window.location.href = "/"
  }

  trackSaveAndExitEvent = () => {
    const { dispatch, previewShowing } = this.props
    const { sessionID, } = this.state

    if(!previewShowing) {
      const activityID = getParameterByName('uid', window.location.href)
      dispatch(TrackAnalyticsEvent(Events.EVIDENCE_ACTIVITY_SAVED, {
        activityID: activityID,
        sessionID
      }))
    }
  }

  saveAndExit = () => {
    const { sessionID, } = this.state
    this.trackSaveAndExitEvent()
    if (sessionID) {
    } else {
      this.goToLMS()
    }
  }

  handleOnClick = () => {
    this.saveAndExit()
  }

  handleTogglePreview = () => {
    const { onTogglePreview } = this.props;
    onTogglePreview();
  }

  renderNumberOrIcon = (step: number) => {
    const { session } = this.props;
    const { activeStep, activityIsComplete } = session;
    if(activityIsComplete || step < activeStep) {
      return checkIcon;
    }
    if(step === activeStep) {
      return <div className="evidence-step-number-small active">{step}</div>
    }
    return <div className="evidence-step-number-small">{step}</div>
  }

  renderActivityTypeTag = () => {
    const { activities } = this.props;
    const activityType = activities?.currentActivity?.activity_type;

    const label = ACTIVITY_TYPE_TAG_LABEL[activityType];
    if (!label) { return null }
    return <span className="activity-type-tag">{label}</span>;
  }

  renderStepCounter = () => {
    const { activities } = this.props;
    const steps = getActivitySteps(activities);
    return(
      <div className="nav-steps-count-container">
        <p className="step-counter-label">Steps</p>
        {steps.map(step => <React.Fragment key={step}>{this.renderNumberOrIcon(step)}</React.Fragment>)}
      </div>
    );
  }

  render() {
    const { session, isTeacher, previewShowing, isOnMobile } = this.props;
    const { explanationSlidesCompleted } = session;
    const showStepsCounter = explanationSlidesCompleted
    const isNotTurk = !window.location.href.includes('turk')
    const tooltipTrigger = <div><img alt="Question mark icon" src={helpIcon} /><span>Beta: <span>in development</span></span></div>
    // we check previewShowing is false because it may initially be returned as null
    const showTeacherPreviewMenuButton = (isTeacher || hasTeacherPreview()) && previewShowing === false;
    const mobileStyle = isOnMobile || (!showStepsCounter && !showTeacherPreviewMenuButton) ? 'mobile' : '';

    return (
      <div className="header">
        <div className={`inner-header ${mobileStyle}`}>
          <div className={`left-side-container ${mobileStyle}`}>
            <div className="left-side">
              <a className="focus-on-dark" href={window.postbuildEnv.DEFAULT_URL}>
                <img alt="Quill.org logo" className="hide-on-desktop" src={mobileLogoSrc} />
                <img alt="Quill.org logo" className="hide-on-mobile" src={logoSrc} />
              </a>
              <Tooltip
                tooltipText="Quill Reading for Evidence is in beta, which means that it’s not perfect yet. As you complete activities, you may notice some issues—a button may not work or some feedback could be unhelpful. Please know that we’re actively working on Quill Reading for Evidence and making improvements every day."
                tooltipTriggerText={tooltipTrigger}
                tooltipTriggerTextClass="hide-on-mobile beta-tag focus-on-dark"
              />
              <span className="hide-on-desktop beta-tag">Beta</span>
            </div>
            {showTeacherPreviewMenuButton && <TeacherPreviewMenuButton onTogglePreview={this.handleTogglePreview} />}
            {showStepsCounter && !isOnMobile && this.renderActivityTypeTag()}
          </div>
          <div className={`right-side-container ${mobileStyle}`}>
            {showStepsCounter && !isOnMobile && this.renderStepCounter()}
            {isNotTurk && <button className="save-and-exit focus-on-dark" onClick={this.handleOnClick} type="button"><span>Save and Exit</span></button>}
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    session: state.session,
    activities: state.activities
  };
};

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>) => {
  return {
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header)
